import { daysFromNow } from './format.js';

/**
 * Read the account's subscription state off `subscription_expire_date`.
 *
 * Deliberately the backend-expiry side of the two-sided entitlement model
 * only: the store-receipt side lives on the device that made the purchase and
 * the web has no view of it. A parent whose subscription is store-held but
 * whose backend expiry has lapsed will read as expired here — which is why the
 * subscription page points at the store rather than claiming to be the source
 * of truth.
 */
export function subscriptionStatus(user) {
  const iso = user?.subscription_expire_date || '';
  if (!iso) return { state: 'none', expiresAt: null, daysLeft: null };

  const days = daysFromNow(iso);
  if (days == null) return { state: 'none', expiresAt: null, daysLeft: null };

  return {
    state: days >= 0 ? 'active' : 'expired',
    expiresAt: iso,
    daysLeft: days,
  };
}
